module.exports = __webpack_public_path__ + "static/media/26.f9af78ca.jpg";